
<div style="width: 100%; height: 100%; padding-left: 32px; padding-right: 32px; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
    <div data-style="Outlined" style=" position: relative; overflow: hidden">
      <mat-icon class="big-icon">supervised_user_circle</mat-icon>
    </div>
    <div data-gutter-bottom="False" data-variant="h6" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
        <div style="align-self: stretch; color: rgba(0, 0, 0, 0.60); font-size: 20px; font-family: Roboto; font-weight: 500; line-height: 32px; letter-spacing: 0.15px; word-wrap: break-word">Users Groups</div>
    </div>
  </div>
  <div class="column">
    <div class="task--search-bar">
        <mat-form-field appearance="outline" class="search--input">
            <mat-label>Type  name to find</mat-label>
            <input matInput type="text" placeholder="Type user name to find" [(ngModel)]="query" (ngModelChange)="onSearch()">
            <button matSuffix mat-icon-button>
                <mat-icon>search</mat-icon>
              </button>
          </mat-form-field>
<div class="task--search-bar-items">
      <app-icon-detail [model]="this.userModel"></app-icon-detail>
            <button class="continue" (click)="addNewUserGroup()" mat-button> <mat-icon [svgIcon]="icons.YesIcon"></mat-icon>
              Add Group</button>
</div>
 
      
    </div>
    <div class="mat-elevation-z8">
        <table   mat-table matSort aria-label="Elements">
 
        
            <ng-container matColumnDef="groupName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let row">{{row.groupName}}</td>
            </ng-container>
    
            <ng-container matColumnDef="members">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Members</th>
              <td mat-cell *matCellDef="let row">{{row.members}}</td>
            </ng-container>
    
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created date</th>
              <td mat-cell *matCellDef="let row">{{ row.createAt | date:'MM/dd/yyyy h:mm a' }}</td>
            </ng-container>
    
            <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created by</th>
              <td mat-cell *matCellDef="let row">{{row.createdBy}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th style="background-color: #E3E3E3;" mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                <button mat-icon-button class="menu-item-danger" [attr.aria-label]="'Delete ' + row.groupName"
                        matTooltip="Delete" (click)="deleteUserGroup(row)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"[routerLink]="['/app/manageUserGroup/', row.id]"
                style="cursor: pointer;">
              </tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                No data matching the filter.
              </td>
            </tr>
          </table>
          <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
          [pageSizeOptions]="[5, 10, 20]" aria-label="Select page">
        </mat-paginator>
    </div>
  </div>